import { render, staticRenderFns } from "./japanese-hiragana.vue?vue&type=template&id=055268f2&scoped=true&"
import script from "./japanese-hiragana.vue?vue&type=script&lang=js&"
export * from "./japanese-hiragana.vue?vue&type=script&lang=js&"
import style0 from "./japanese-hiragana.vue?vue&type=style&index=0&id=055268f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055268f2",
  null
  
)

export default component.exports